export default {
  "loginHistory.thead.index": "#NO",
  "loginHistory.thead.userno": "Userno",
  "loginHistory.thead.clientIp": "ClientIp",
  "loginHistory.thead.header": "Header",
  "loginHistory.thead.createTime": "CreateTime",
  "loginHistory.tooltip.copy.userno": "Copy Userno",
  "loginHistory.tooltip.showUserDetails": "ShowUserDetails",
};
